import c from 'classnames';
import React, { ReactNode } from 'react';
import styles from './styles.m.less';

type Props = {
    step?: string;
    title?: string;
    subtitle?: string | ReactNode;
    imageURL?: string;
    quote?: string;
    author?: string;
    role?: string;
    authorImage?: string;
    children: React.ReactNode;
    illustration?: React.ReactNode;
    sidebarClasses?: string;
};

export default function RegisterFlowTemplate({
    step,
    imageURL,
    quote,
    author,
    role,
    authorImage,
    children,
    title,
    subtitle,
    illustration,
    sidebarClasses,
}: Props) {
    return (
        <div className={styles['promo_sidebar-wrapper']}>
            <div className={styles.contentWrapper}>
                <div className={styles.header}>
                    <a href="/">
                        <img
                            alt="Small Improvements"
                            className={styles['no_auth_prompt-header-logo']}
                            src="/images/logo/2020/si-logo-2lines-color.svg"
                        ></img>
                    </a>
                </div>
                <div className={styles.contentContainer}>
                    <div className={styles.registerPanel}>
                        <div className={styles.registerCardInner}>
                            <div className={styles.title}>
                                {!!step && <p>{step} of 5</p>}
                                <h1>{title ? `${title}` : 'Finish your profile setup'}</h1>
                                {subtitle && <h2 className={styles.subtitle}>{subtitle}</h2>}
                            </div>
                            {children}
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.promo_sidebar}>
                <div className={c(styles['promo_sidebar-inner'], styles['register_sidebar-inner'])}>
                    <div
                        className={c(
                            styles['promo_sidebar-center'],
                            styles['register_sidebar-first_section'],
                            sidebarClasses
                        )}
                    >
                        {illustration}
                        {imageURL && <img alt="" className={styles['promo_sidebar-image']} src={imageURL} />}
                        {quote && (
                            <div className={c(styles['promo_sidebar-center'], styles['register_sidebar-text'])}>
                                <p className={styles['register_sidebar-quote']}>{quote}</p>
                                <div className={styles.register_author_quote_container}>
                                    <img alt="" src={authorImage} />
                                    <div>
                                        <p className={styles['register_sidebar-author']}>{author}</p>
                                        <p className={styles['register_sidebar-role']}>{role}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
